import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=a4ec0108&scoped=true&"
import script from "./alarm.vue?vue&type=script&lang=js&"
export * from "./alarm.vue?vue&type=script&lang=js&"
import style0 from "./alarm.vue?vue&type=style&index=0&id=a4ec0108&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec0108",
  null
  
)

export default component.exports